/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DevelopmentRegistrationStep = "first_buyer" | "result" | "second_buyer" | "verification";
export type UpsertDevelopmentRegistrationFormInput = {|
  developmentRegistrationForm?: ?DevelopmentRegistrationFormInput,
  clientMutationId?: ?string,
|};
export type DevelopmentRegistrationFormInput = {|
  id?: ?string,
  productId?: ?string,
  developmentProductId?: ?string,
  firstBuyerFirstName?: ?string,
  firstBuyerLastName?: ?string,
  firstBuyerEmailAddress?: ?string,
  firstBuyerPhoneNumber?: ?string,
  emailAddress?: ?string,
  phoneNumber?: ?string,
  numberOfBuyers?: ?number,
  isAlreadyOwner?: ?boolean,
  inviteSecondBuyer?: ?boolean,
  firstBuyerDateOfBirth?: ?string,
  firstBuyerOccupationId?: ?string,
  firstBuyerNationalityId?: ?string,
  firstBuyerWorkPermitId?: ?string,
  firstBuyerAnnualRevenues?: ?number,
  firstBuyerSavings?: ?number,
  firstBuyerUseOfSecondPillar?: ?boolean,
  firstBuyerSecondPillar?: ?number,
  firstBuyerUseOfThirdPillar?: ?boolean,
  firstBuyerThirdPillar?: ?number,
  secondBuyerFirstName?: ?string,
  secondBuyerLastName?: ?string,
  secondBuyerEmailAddress?: ?string,
  secondBuyerPhoneNumber?: ?string,
  secondBuyerDateOfBirth?: ?string,
  secondBuyerOccupationId?: ?string,
  secondBuyerNationalityId?: ?string,
  secondBuyerWorkPermitId?: ?string,
  secondBuyerAnnualRevenues?: ?number,
  secondBuyerSavings?: ?number,
  secondBuyerUseOfSecondPillar?: ?boolean,
  secondBuyerSecondPillar?: ?number,
  secondBuyerUseOfThirdPillar?: ?boolean,
  secondBuyerThirdPillar?: ?number,
  maximumBudget?: ?number,
  buyApartment?: ?boolean,
  buyHouse?: ?boolean,
  minNumberOfBedrooms?: ?number,
  buyGroundFloor?: ?boolean,
  buyIntermediateFloor?: ?boolean,
  buyTopFloor?: ?boolean,
  hasLandForSale?: ?boolean,
  step?: ?DevelopmentRegistrationStep,
|};
export type useSubmitRegistrationUpsertMutationVariables = {|
  input: UpsertDevelopmentRegistrationFormInput
|};
export type useSubmitRegistrationUpsertMutationResponse = {|
  +upsertDevelopmentRegistrationForm: ?{|
    +developmentRegistrationForm: ?{|
      +id: string,
      +step: ?DevelopmentRegistrationStep,
    |}
  |}
|};
export type useSubmitRegistrationUpsertMutation = {|
  variables: useSubmitRegistrationUpsertMutationVariables,
  response: useSubmitRegistrationUpsertMutationResponse,
|};
*/


/*
mutation useSubmitRegistrationUpsertMutation(
  $input: UpsertDevelopmentRegistrationFormInput!
) {
  upsertDevelopmentRegistrationForm(input: $input) {
    developmentRegistrationForm {
      id
      step
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpsertDevelopmentRegistrationFormPayload",
    "kind": "LinkedField",
    "name": "upsertDevelopmentRegistrationForm",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DevelopmentRegistrationForm",
        "kind": "LinkedField",
        "name": "developmentRegistrationForm",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "step",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSubmitRegistrationUpsertMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSubmitRegistrationUpsertMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8fe0764dfd59b0b8f87c37bd83af73a6",
    "id": null,
    "metadata": {},
    "name": "useSubmitRegistrationUpsertMutation",
    "operationKind": "mutation",
    "text": "mutation useSubmitRegistrationUpsertMutation(\n  $input: UpsertDevelopmentRegistrationFormInput!\n) {\n  upsertDevelopmentRegistrationForm(input: $input) {\n    developmentRegistrationForm {\n      id\n      step\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b90ea3aadd84c1ff1ae0c8f219c87910';

export default node;
